import script from "./ConfirmPermissionChanges.vue?vue&type=script&setup=true&lang=ts"
export * from "./ConfirmPermissionChanges.vue?vue&type=script&setup=true&lang=ts"

import "./ConfirmPermissionChanges.vue?vue&type=style&index=0&id=657af5dd&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-657af5dd"]])

export default __exports__